<div class="sc-container">
  <!-- Cinematic Background Elements (Sync with Login) -->
  <div class="bg-blobs">
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>
    <div class="blob blob-3"></div>
  </div>
  <div class="glass-fragments">
    <div class="fragment frag-1"></div>
    <div class="fragment frag-2"></div>
    <div class="fragment frag-3"></div>
  </div>
  <!-- Split-Design Toolbar -->
  <mat-toolbar class="main-toolbar">
    <div class="brand-block">
      <div class="logo-wrapper">
        <img src="https://www.thescope.com/hubfs/Scope-Prisma.png" class="brand-logo" alt="Scope Logo" />
        <span class="brand-suffix">Scope Admin</span>
      </div>
    </div>

    <div class="toolbar-actions">
      <button mat-icon-button (click)="toggleSidenav()" class="nav-toggle">
        <mat-icon>{{ isSidenavOpen ? 'menu_open' : 'menu' }}</mat-icon>
      </button>

      <div class="page-context">
        <span class="context-label">Dashboard Overview</span>
      </div>

      <div class="user-chip">
        <div class="avatar-circle">{{ (user | async).firstName?.charAt(0) }}{{ (user | async).lastName?.charAt(0) }}</div>
        <span class="user-name">{{ (user | async).firstName }}</span>
        <div class="v-divider"></div>
        <button mat-icon-button class="logout-action" (click)="logout()" matTooltip="Sign Out">
          <mat-icon>power_settings_new</mat-icon>
        </button>
      </div>
    </div>
  </mat-toolbar>

  <!-- Navigation progress bar: shows during lazy-module load + route resolvers
  so slow backend calls don't make the app look frozen after a click. -->
  @if (navLoading) {
  <div class="nav-progress" role="progressbar" aria-label="Loading"></div>
  }

  <mat-sidenav-container class="main-container">
    <mat-sidenav [mode]="sidenavMode" [(opened)]="isSidenavOpen" #sideNav>
      <mat-nav-list class="premium-nav-list">
        <div class="nav-section">
          <div class="section-hdr">Workspaces</div>
          <a mat-list-item [ngClass]="{ active: boxRouteActive }" routerLink="/boxes" [queryParams]="{ boxStatus: 'ONLINE' }">
            <mat-icon>grid_view</mat-icon>
            <span class="link-text">Environment Overview</span>
          </a>
          <a mat-list-item [ngClass]="{ active: boxCloneRouteActive }" routerLink="/boxes/clone">
            <mat-icon>library_add</mat-icon>
            <span class="link-text">Clone Setup</span>
          </a>
          <a mat-list-item routerLinkActive="active" routerLink="/users">
            <mat-icon>manage_accounts</mat-icon>
            <span class="link-text">Curator Access</span>
          </a>
        </div>

        <div class="nav-divider"></div>

        <div class="nav-section">
          <div class="section-hdr">Platform Assets</div>
          <a mat-list-item routerLinkActive="active" routerLink="/templates">
            <mat-icon>auto_fix_high</mat-icon>
            <span class="link-text">Mustache Templates</span>
          </a>
          <a mat-list-item routerLinkActive="active" routerLink="/mustache-values">
            <mat-icon>data_array</mat-icon>
            <span class="link-text">JSON Variable Maps</span>
          </a>
          <a mat-list-item routerLinkActive="active" routerLink="/translations">
            <mat-icon>public</mat-icon>
            <span class="link-text">Global Translations</span>
          </a>
        </div>

        <div class="nav-divider"></div>

        <div class="nav-section">
          <div class="section-hdr">Infrastructure</div>
          <a mat-list-item routerLinkActive="active" routerLink="/manifold" class="manifold-nav-link">
            <mat-icon [ngClass]="manifoldStatus">analytics</mat-icon>
            <span class="link-text">Monitoring</span>
            @if (manifoldStatus) {
            <div class="manifold-status-badge" [ngClass]="manifoldStatus">
              <span class="pulse-ring"></span>
              <span class="status-text">{{
                manifoldStatus === 'paused'
                  ? 'PAUSED'
                  : manifoldStatus === 'green'
                  ? 'LIVE'
                  : manifoldStatus === 'yellow'
                  ? 'WARN'
                  : manifoldStatus === 'indigo'
                  ? 'VER'
                  : 'ERR'
              }}</span>
            </div>
            }
          </a>
          <a mat-list-item routerLinkActive="active" routerLink="/file-versions">
            <mat-icon>history_toggle_off</mat-icon>
            <span class="link-text">Version History</span>
          </a>
          <a mat-list-item routerLinkActive="active" routerLink="/system">
            <mat-icon>tune</mat-icon>
            <span class="link-text">Settings</span>
          </a>
        </div>

        <div class="nav-divider"></div>

        <div class="nav-section">
          <div class="section-hdr">Discovery</div>
          <a mat-list-item routerLinkActive="active" routerLink="/discovery/enrichment">
            <mat-icon>insights</mat-icon>
            <span class="link-text">Enrichment</span>
          </a>
          <!-- not routerLinkActive: /discovery would also match /discovery/enrichment -->
          <a mat-list-item [class.active]="dataTablesActive" routerLink="/discovery">
            <mat-icon>table_view</mat-icon>
            <span class="link-text">Data Tables</span>
          </a>
        </div>
      </mat-nav-list>

      <div class="sidebar-footer">
        <a mat-list-item routerLinkActive="active" routerLink="/help" class="help-item">
          <mat-icon>contact_support</mat-icon>
          <span class="link-text">Support & Docs</span>
        </a>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="content-viewport">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
